
import React, { Component } from 'react'
import { Overlay } from "../../styles/global"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Container, Button, Typography } from '@mui/material'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as componentActions from "../../redux/actions/users"
import Logo from '../../components/logo/logo';
import { FormattedMessage } from 'react-intl'
import { injectIntl } from 'react-intl'
//import Api from '../../services/api'
import './style.css'

class Unavailable extends Component {

    constructor(props) {
      super(props);

      if (window.performance) {
        if (performance.navigation.type == 1) {
          var l = this.props.match.params.lang;
          document.location.href=`/${l}/`
        }
      }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */
    render() {
        return (
            <div
                style={{
                    background: "white",
                    height: '100%'
                }}>
              <Container component="main" style={{ paddingTop: 150, display: 'flex', alignItems: 'center' }}>
                <div
                    style={{
                        float: 'left',
                        width: '50%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        paddingRight: '5%'
                    }}>
                    <Logo key="groups-fieldservice-awrar6aw15" />
                </div>
                <div style={{ float: 'right', width: '50%', paddingLeft: 30 }}>
                  <Typography variant="h3" style={{ fontSize: '2em', color: 'black', fontWeight: 500, marginTop: '1em', marginBottom: '1em' }}>
                    {<FormattedMessage values={{ br: <br /> }} id="system.temporarily.unavailable" />}
                  </Typography>
                  <Typography variant="h5" style={{ fontSize: '1.5em', color: '#37363D', fontWeight: 500, marginBottom: '1em' }}>
                    {<FormattedMessage values={{ br: <br /> }} id="unavailable.contact" />}
                  </Typography>
                  <Typography variant="h5" style={{ color: '#37363D', fontWeight: 100, marginBottom: '1em' }}>
                    {<FormattedMessage id="contact.cmtech" />}
                  </Typography>
                    <Button variant='outlined' color='primary' variant='contained' onClick={e => {
                      var l = this.props.match.params.lang;
                      document.location.href=`/${l}/`
                    }}>{<FormattedMessage id="update" />}</Button>
                </div>
              </Container>
            </div>
        );
    }

}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(componentActions, dispatch);

export default connect(null, mapDispatchToProps)(withStyles(Styles)(Unavailable));